import PropTypes from "prop-types";
import { Chip, Tooltip } from "@mui/material";
import {
  Sync,
  HourglassTop,
  TaskAlt,
  SendOutlined,
  LayersOutlined,
  CompareArrows,
  ErrorOutline,
  HelpOutline,
} from "@mui/icons-material";

const tones = {
  blue: { color: "#1d4ed8", background: "#eff6ff", border: "#bfdbfe" },
  amber: { color: "#92400e", background: "#fffbeb", border: "#fde68a" },
  green: { color: "#166534", background: "#f0fdf4", border: "#bbf7d0" },
  teal: { color: "#0f766e", background: "#f0fdfa", border: "#99f6e4" },
  cyan: { color: "#0e7490", background: "#ecfeff", border: "#a5f3fc" },
  purple: { color: "#6d28d9", background: "#f5f3ff", border: "#ddd6fe" },
  indigo: { color: "#3730a3", background: "#eef2ff", border: "#c7d2fe" },
  emerald: { color: "#047857", background: "#ecfdf5", border: "#a7f3d0" },
  red: { color: "#b91c1c", background: "#fef2f2", border: "#fecaca" },
  neutral: { color: "#475569", background: "#f1f5f9", border: "#cbd5e1" },
};
const states = {
  0: ["Pendiente", "amber"],
  1: ["En Proceso", "blue"],
  2: ["Completado", "green"],
  3: ["Enviado", "teal"],
  "pre liquidacion": ["Preliquidación", "purple"],
  preliquidacion: ["Preliquidación", "purple"],
  "pre conciliacion": ["Preconciliación", "purple"],
  preconciliacion: ["Preconciliación", "purple"],
  liquidado: ["Liquidado", "indigo"],
  liquidada: ["Liquidado", "indigo"],
  "auto liquidado": ["Autoliquidado", "emerald"],
  "auto liquidada": ["Autoliquidado", "emerald"],
  "pendiente subir reporte": ["Pendiente de reporte", "amber"],
  liquidar: ["Por liquidar", "amber"],
  "en liquidacion": ["En liquidación", "cyan"],
  "conciliado liquidar": ["Conciliado · Por liquidar", "teal"],
  "liquidacion de pago": ["Liquidación de pago", "amber"],
  "en conciliacion": ["En conciliación", "cyan"],
  pagado: ["Pagado", "green"],
  pagada: ["Pagado", "green"],
  "con diferencia": ["CON_DIFERENCIA", "red"],
  "sin diferencia": ["SIN_DIFERENCIA", "green"],
  "no se pudo liquidar": ["No se pudo liquidar", "red"],
  error: ["Error", "red"],
  pendiente: ["Pendiente", "amber"],
  iniciado: ["Iniciado", "blue"],
  iniciada: ["Iniciada", "blue"],
  "en proceso": ["En Proceso", "blue"],
  "en proceso lote": ["Lote en proceso", "cyan"],
  procesando: ["Procesando", "blue"],
  completado: ["Completado", "green"],
  completada: ["Completada", "green"],
  finalizado: ["Finalizado", "green"],
  finalizada: ["Finalizada", "green"],
  enviado: ["Enviado", "teal"],
  enviada: ["Enviada", "teal"],
};
export const rowConciliationStatus = (row) =>
  ["conciliado-liquidar", "pagado", "pagada"].includes(
    String(row.status || "")
      .trim()
      .toLowerCase()
  )
    ? row.status
    : row.estado_cuadre || row.status || "0";

export function conciliationStatus(value) {
  const raw = String(value ?? "").trim();
  const normalized = raw
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[_\s-]+/g, " ");
  const [label, tone] = states[normalized] || [raw || "No informado", "neutral"];
  return { label, tone, ...tones[tone] };
}
const statusIcons = {
  blue: Sync,
  amber: HourglassTop,
  green: TaskAlt,
  teal: SendOutlined,
  purple: LayersOutlined,
  indigo: TaskAlt,
  emerald: TaskAlt,
  cyan: CompareArrows,
  red: ErrorOutline,
  neutral: HelpOutline,
};
export default function ConciliationStatusChip({ value }) {
  const status = conciliationStatus(value);
  const StatusIcon = statusIcons[status.tone];
  return (
    <Tooltip title={status.label} arrow>
      <Chip
        icon={<StatusIcon />}
        label={status.label}
        size="small"
        sx={{
          "&&": {
            width: 160,
            maxWidth: "100%",
            height: 30,
            borderRadius: "8px",
            fontWeight: 700,
            bgcolor: status.color,
            color: "#fff",
            border: "1px solid transparent",
            justifyContent: "flex-start",
          },
          "&& .MuiChip-icon": { color: "#fff", fontSize: 17, ml: "9px", mr: 0 },
          "&& .MuiChip-label": { fontSize: 12, px: "8px", lineHeight: 1.2 },
        }}
      />
    </Tooltip>
  );
}
ConciliationStatusChip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
